import ListItemSkeleton from "./ListItemSkeleton";

type Props = {
  withChips?: boolean;
};

export default function ListSkeleton({ withChips = true }: Props) {
  return (
    <div className="list-skeleton" data-testid="list-skeleton">
      <ListItemSkeleton withChips={withChips} />
      <ListItemSkeleton withChips={withChips} />
      <ListItemSkeleton withChips={withChips} />
    </div>
  );
}
